import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import AbstractSubmissionReceipt from '@/components/reviewSubmission/AbstractSubmissionReceipt.vue'
    import router from '@/router'
    import { useRoute } from 'vue-router'
    import MainTemplate from '@/components/MainTemplate.vue'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DataErrorSubmission',
  setup(__props) {

    const route = useRoute()
    const handleReturnToFnol = () => {
      router.push({ name: 'FNOL Review and Submission', params: { visible: 'true' }, query: { data: route.query.data } })
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MainTemplate, null, {
    default: _withCtx(() => [
      _createVNode(AbstractSubmissionReceipt, {
        class: "self",
        header: 'termsAndConditions.reviewSubmission.header',
        reason: 'termsAndConditions.reviewSubmission.dataError.reason',
        title: 'termsAndConditions.reviewSubmission.dataError.title'
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", { onClick: handleReturnToFnol }, _toDisplayString(_ctx.$t('termsAndConditions.reviewSubmission.dataError.highLight')), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})